import { Component, inject, ChangeDetectorRef, Input } from '@angular/core';
import { _HttpClient } from '@delon/theme';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-einvoice-validation-confirmation',
  templateUrl: './einvoice-confirmation-modal.component.html',
  styleUrls: ['./einvoice-confirmation-modal.component.less'],
  providers: [],
  standalone: false
})
export class EinvoiceConfirmationModalComponent {
  private http = inject(_HttpClient);
  private cdr = inject(ChangeDetectorRef);
  submitMode = 0;

  modalVisible: boolean = false;
  data: any = {};
  loading = false;
  isPurchase = false;
  customerParty: any = {};
  supplierParty: any = {};
  okLoading = false;

  @Input() onConfirm!: (options: any) => Promise<boolean>;

  show(docId: string, docType: string) {
    if (docType && ['pinv', 'pdn', 'pcn', 'cp'].includes(docType.toLowerCase())) {
      this.isPurchase = true;
    }
    this.loading = true;
    this.okLoading = false;
    this.modalVisible = true;
    this.cdr.detectChanges();
    this.http
      .get(`/api/einvoices/DocumentSummary`, { docId, docType })
      .pipe(
        finalize(() => {
          this.loading = false;
          this.cdr.detectChanges();
        })
      )
      .subscribe((res: any) => {
        this.data = { ...res };
        this.customerParty = { ...res.customerParty };
        this.supplierParty = { ...res.supplierParty };
      });
  }

  handleOk() {
    if (this.onConfirm) {
      this.okLoading = true;
      const options = { submitMode: this.submitMode };
      this.onConfirm(options)
        .then((res: boolean) => {
          if (res) {
            this.okLoading = true;
            this.modalVisible = false;
          } else {
            this.okLoading = false;
          }
        })
        .catch(() => {
          this.okLoading = false;
        });
    } else {
      this.modalVisible = false;
    }
  }

  handleCancel() {
    this.modalVisible = false;
  }
}
